import { ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';
import { Link } from '../../../common/Link';
import { PaymentStatusContainer } from '../PaymentStatus';
import * as styles from './BalanceMobile.css';
import { useBalance } from '../../hooks';

export const BalanceMobile = () => {
  const { showBalance, withPay, balanceString, handleDepositLinkClick } = useBalance();

  return (
    <>
      {showBalance && (
        <div className={styles['balance_wrapper']}>
          <ArticleParagraph1>Баланс</ArticleParagraph1>

          {balanceString && (
            <ArticleParagraph1 as="div" textAlign="right">
              <div className={styles['balance']}>{balanceString}</div>

              {withPay && <Link onClick={handleDepositLinkClick}>Пополнить</Link>}
            </ArticleParagraph1>
          )}
        </div>
      )}

      <PaymentStatusContainer />
    </>
  );
};
